// This enum contains the event types managed by the web client app
export enum EventTypes {
   visit,
   commute,
   travelTime,
   lunch,
   overnight,
   project
}
